export const authActionType = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAIL: 'LOGIN_FAIL',
  LOGOUT: 'LOGOUT',
  SERVER_ERROR: 'SERVER_ERROR',
  PAGE_NOT_FOUND: 'PAGE_NOT_FOUND'
};
export const campaignStatuses = [
  { label: 'All', value: undefined },
  { label: 'Active', value: 'active' },
  { label: 'Review', value: 'review' },
  { label: 'Bounced', value: 'bounced' },
  { label: 'Paused', value: 'paused' },
  { label: 'Completed', value: 'completed' },
  { label: 'Closed (Successful)', value: 'closed_success' },
  { label: 'Closed (Unsuccessful)', value: 'closed_unsuccess' }
];

export const allState = [
  {
    label: 'Active',
    value: 'active'
  },
  {
    label: 'Review',
    value: 'review'
  },
  {
    label: 'Completed',
    value: 'completed'
  },
  {
    label: 'Pause',
    value: 'paused'
  },
  {
    label: 'Closed (Successful)',
    value: 'closed_success'
  },
  {
    label: 'Closed (Unsuccessful)',
    value: 'closed_unsuccess'
  }
];

export const emailTemplateVariables = [
  {
    label: 'Candidate Name',
    value: '{{candidateName}}'
  },
  {
    label: 'Employee Id',
    value: '{{candidateId}}'
  },
  {
    label: 'Candidate Designation',
    value: '{{designation}}'
  },
  {
    label: 'Candidate Company',
    value: '{{company}}'
  },
  {
    label: 'Client Name',
    value: '{{client}}'
  },
  {
    label: 'Date Of Joining',
    value: '{{doj}}'
  },
  {
    label: 'Last Working Date',
    value: '{{lastWorkingDate}}'
  },
  {
    label: 'Remuneration',
    value: '{{remuneration}}'
  },
  {
    label: 'Remuneration Type',
    value: '{{remunerationType}}'
  },
  {
    label: 'Remuneration Comment',
    value: '{{remunerationComment}}'
  },
  {
    label: 'Reporting Manager',
    value: '{{reportingManager}}'
  },
  {
    label: 'Reason Of Leaving',
    value: '{{reasonOfLeaving}}'
  },
  {
    label: 'Nature Of Employement',
    value: '{{natureOfEmployement}}'
  },
  {
    label: 'Company Location',
    value: '{{companyLocation}}'
  }
];

export const verificationTableHTML = `<table style="width: 100%; border-collapse: collapse; height: 162px;"><tbody><tr style="color: #ffffff;"><th style="border: 1px solid #000000; padding: 5px; margin: 0px; width: 50%; text-align: left; background: #1024fb; height: 42px;">&nbsp;</th><th style="border: 1px solid #000000; padding: 5px; margin: 0px; width: 25%; text-align: left; background: #1024fb; height: 42px;">Details Approved By The Candidates</th><th style="border: 1px solid #000000; padding: 5px; margin: 0px; width: 25%; text-align: left; background: #1024fb; height: 42px;">Comments By HR/Company</th></tr><tr style="height: 20px;"><td style="border: 1px solid #000000; padding: 5px; margin: 0px; height: 20px;"><strong>Candidate Name <span style="color:red">*</span></strong></td><td style="border: 1px solid #000000; padding: 5px; margin: 0px; height: 20px;">&nbsp;<em>{{candidateName}}</em></td><td style="border: 1px solid #000000; padding: 5px; margin: 0px; height: 20px;">NA</td></tr><tr style="height: 20px;"><td style="border: 1px solid #000000; padding: 5px; margin: 0px; height: 20px;"><strong>EMP ID</strong></td><td style="border: 1px solid #000000; padding: 5px; margin: 0px; height: 20px;">&nbsp;<em>{{employeeId}}</em></td><td style="border: 1px solid #000000; padding: 5px; margin: 0px; height: 20px;">NA</td></tr><tr style="height: 20px;"><td style="border: 1px solid #000000; padding: 5px; margin: 0px; height: 20px;"><strong>Company Name <span style="color:red">*</span></strong></td><td style="border: 1px solid #000000; padding: 5px; margin: 0px; height: 20px;">&nbsp;<em>{{company}}</em></td><td style="border: 1px solid #000000; padding: 5px; margin: 0px; height: 20px;">&nbsp;</td></tr><tr style="height: 20px;"><td style="border: 1px solid #000000; padding: 5px; margin: 0px; height: 20px;"><strong>Date of joining</strong></td><td style="border: 1px solid #000000; padding: 5px; margin: 0px; height: 20px;">{{dateOfJoining}}</td><td style="border: 1px solid #000000; padding: 5px; margin: 0px; height: 20px;">&nbsp;</td></tr><tr style="height: 20px;"><td style="border: 1px solid #000000; padding: 5px; margin: 0px; height: 20px;"><strong>Last Working Date</strong></td><td style="border: 1px solid #000000; padding: 5px; margin: 0px; height: 20px;">{{lastWorkingDate}}</td><td style="border: 1px solid #000000; padding: 5px; margin: 0px; height: 20px;">&nbsp;</td></tr><tr style="height: 20px;"><td style="border: 1px solid #000000; padding: 5px; margin: 0px; height: 20px;"><strong>Designation</strong></td><td style="border: 1px solid #000000; padding: 5px; margin: 0px; height: 20px;">{{designation}}</td><td style="border: 1px solid #000000; padding: 5px; margin: 0px; height: 20px;">&nbsp;</td></tr></tbody></table>`;
